<script>
import LightCheckoutSection from '@phoenix/mixins/components/light-checkout/LightCheckoutSection';

export default {
  mixins: [LightCheckoutSection],

  props: {
    subtitle: {
      type: String,
      default: null,
    },
  },
};
</script>

<template>
  <div :id="`checkout-section-${name}`" class="checkout-section">
    <header class="checkout-section__header">
      <h3 class="text-lg">{{ title }}</h3>
    </header>

    <div v-if="$slots.default" class="checkout-section__body">
      <p v-if="subtitle" class="mt-0 text-black-50">{{ subtitle }}</p>
      <slot></slot>
    </div>
  </div>
</template>
